export default "__VITE_ASSET__CQatVsv6__"